var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import { useAutoFocus, useAutoFocusContainer, useRestoreFocus, useDisableClickOutside, useFocusLock, } from './internal';
export const useFocusTrap = (props = {}) => {
    const { autoFocus = false, autoFocusContainer = false, disabled = false, disableClickOutside = false, focusLock = true, restoreFocus = true, shards = [] } = props, rest = __rest(props, ["autoFocus", "autoFocusContainer", "disabled", "disableClickOutside", "focusLock", "restoreFocus", "shards"]);
    const focusTrapRef = useRef(null);
    const scope = [focusTrapRef, ...shards];
    useRestoreFocus({ enabled: !disabled && restoreFocus });
    useAutoFocusContainer({
        containerRef: focusTrapRef,
        enabled: !disabled && autoFocusContainer,
    });
    useAutoFocus({
        scope,
        enabled: !disabled && autoFocus,
    });
    useDisableClickOutside(Object.assign({ scope, enabled: !disabled && disableClickOutside }, rest));
    useFocusLock({
        scope,
        enabled: !disabled && focusLock,
    });
    return focusTrapRef;
};
//# sourceMappingURL=useFocusTrap.js.map